let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("d2G22")).then(() => parcelRequire('bOM9f'));